import { create } from 'zustand'

import { checkBudgetValidation, confirmPopup } from './provider'

import type { UseBudgetValidationProps } from './types'

export const useBudgetValidation = create<UseBudgetValidationProps>((set) => ({
  budgetInfo: null,
  setBudgetInfo: (value) => set({ budgetInfo: value }),

  shouldShowPopup: false,
  setShouldShowPopup: (value) => set({ shouldShowPopup: value }),

  checkBudgetValidation,
  confirmPopup
}))
